import { render, staticRenderFns } from "./ModalDebtsBillComponent.vue?vue&type=template&id=3735fa29&scoped=true"
import script from "./ModalDebtsBillComponent.vue?vue&type=script&lang=js"
export * from "./ModalDebtsBillComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalDebtsBillComponent.vue?vue&type=style&index=0&id=3735fa29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735fa29",
  null
  
)

export default component.exports